import { API_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import {
  PATCH,
  POST,
  PUT,
  // PATCH,
  // PUT
} from '../common/consts';

const getBotCommandsAPI = async (data) => {
  const res = await fetch(
    `${API_URL}calendar/cmds?${encodeGetParams({ ...data })}`,
  );
  const result = res.json();
  return result;
};

const saveCaldendarDataAPI = async (data) => {
  const res = await fetch(`${API_URL}calendar`, getHeaders(POST, { ...data }));
  const result = res.json();
  return result;
};

const getRobotGroupsAPI = async ({ userId }) => {
  const res = await fetch(`${API_URL}calendar/groups/${userId}`);
  const result = res.json();
  return result;
};

const getCalendarDataAPI = async ({ userId, robotId, date }) => {
  const res = await fetch(
    `${API_URL}calendar/list/${userId}?${encodeGetParams({ date, robotId })}`,
  );
  const result = res.json();
  return result;
};

const updateCalendarAPI = async ({ userId, list }) => {
  const res = await fetch(
    `${API_URL}calendar`,
    getHeaders(PATCH, { userId, list }),
  );
  const result = res.json();
  return result;
};

const deleteCalendarAPI = async ({ userId, list }) => {
  const res = await fetch(
    `${API_URL}calendar`,
    getHeaders(PUT, { userId, list }),
  );
  const result = res.json();
  return result;
};

export {
  getBotCommandsAPI,
  saveCaldendarDataAPI,
  getRobotGroupsAPI,
  getCalendarDataAPI,
  updateCalendarAPI,
  deleteCalendarAPI,
};
